var render = function () {
  var _vm$product$title, _vm$product$title2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BranchProductStockList",
      "extra-items": _vm.readonly ? [{
        text: (_vm$product$title = _vm.product.title) !== null && _vm$product$title !== void 0 ? _vm$product$title : ''
      }] : _vm.isEdit ? [{
        text: (_vm$product$title2 = _vm.product.title) !== null && _vm$product$title2 !== void 0 ? _vm$product$title2 : '',
        to: 'ProductDetail',
        params: _vm.$route.params.product_id
      }, '編輯商品'] : ['新增商品']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("商品明細")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品名稱"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.title,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "title", $$v);
      },
      expression: "product.title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "販售頁面編號"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.sale_page_code,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "sale_page_code", $$v);
      },
      expression: "product.sale_page_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品分類"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.category,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "category", $$v);
      },
      expression: "product.category"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "原價"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.original_price,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "original_price", $$v);
      },
      expression: "product.original_price"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "售價"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.price,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "price", $$v);
      },
      expression: "product.price"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "成本"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.cost,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "cost", $$v);
      },
      expression: "product.cost"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "最低售價"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.lowest_price,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "lowest_price", $$v);
      },
      expression: "product.lowest_price"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "分店"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.branches
    },
    model: {
      value: _vm.product.branch_id,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "branch_id", $$v);
      },
      expression: "product.branch_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品狀態"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.status,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "status", $$v);
      },
      expression: "product.status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "開始販售時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.product.available_start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.product.available_start_at, "date", $$v);
      },
      expression: "product.available_start_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.product.available_start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.product.available_start_at, "time", $$v);
      },
      expression: "product.available_start_at.time"
    }
  })], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "結束販售時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.product.available_end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.product.available_end_at, "date", $$v);
      },
      expression: "product.available_end_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.product.available_end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.product.available_end_at, "time", $$v);
      },
      expression: "product.available_end_at.time"
    }
  })], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "是否上架"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.product.is_close,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "is_close", $$v);
      },
      expression: "product.is_close"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品類型"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.productTypeOptions
    },
    model: {
      value: _vm.product.type,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "type", $$v);
      },
      expression: "product.type"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "row mt-4 mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("商品規格")])])]), !_vm.readonly ? _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addSkuHandler
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增規格 ")])], 1) : _vm._e(), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.product.skus,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(sku_code)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.sku_code) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.sku_code,
            callback: function callback($$v) {
              _vm.$set(data.item, "sku_code", $$v);
            },
            expression: "data.item.sku_code"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(sku_name)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.sku_name) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.sku_name,
            callback: function callback($$v) {
              _vm.$set(data.item, "sku_name", $$v);
            },
            expression: "data.item.sku_name"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.quantity) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "quantity", $$v);
            },
            expression: "data.item.quantity"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(once_quantity)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.once_quantity) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.once_quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "once_quantity", $$v);
            },
            expression: "data.item.once_quantity"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(once_increase_quantity)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.once_increase_quantity) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.once_increase_quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "once_increase_quantity", $$v);
            },
            expression: "data.item.once_increase_quantity"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(suggest_price)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.suggest_price) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.suggest_price,
            callback: function callback($$v) {
              _vm.$set(data.item, "suggest_price", $$v);
            },
            expression: "data.item.suggest_price"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(price)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.price) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.price,
            callback: function callback($$v) {
              _vm.$set(data.item, "price", $$v);
            },
            expression: "data.item.price"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(cost)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.cost) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.cost,
            callback: function callback($$v) {
              _vm.$set(data.item, "cost", $$v);
            },
            expression: "data.item.cost"
          }
        })], 1)], 1)];
      }
    }])
  }), !_vm.readonly ? _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [[_vm._v("返回")]], 2), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm.isEdit ? [_vm._v("確認編輯")] : _vm._e(), _vm.isCreate ? [_vm._v("確認新增")] : _vm._e()], 2)], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }